import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ModalCloseStrategy, SdModalOptions } from '@shared/v2';
import { SdvorClickOutsideDirective } from '../../../../directives';
import { SdvorIconComponent } from '../../../icon';

@Component({
  selector: 'sd-modal-standard',
  templateUrl: './modal-standard.component.html',
  styleUrls: ['./modal-standard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent, SdvorClickOutsideDirective],
})
export class SdvorModalStandardComponent {
  options = input.required<SdModalOptions>();
  closed = output<void>();

  onClickOutside(): void {
    if (this.options().closeStrategy !== ModalCloseStrategy.Outside || this.options().ignoreOutsideClick) {
      return;
    }

    this.onClose();
  }

  onClose(): void {
    this.closed.emit();
  }
}
